import NotificacionService from "@/api/services/notificacion/NotificacionService"
import Vue from "vue"

const state = () => ({
    notificaciones: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id,notification_gestor_id",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    NOTIFICACIONES: state => {
        return state.notificaciones
    },
    NOTIFICACIONES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_NOTIFICACIONES: (state, payload) => {
        state.notificaciones = payload
    },

    SET_NOTIFICACIONES_PAG: (state, payload) => {
        state.pagination = payload
    },

    UPDATE_NOTIFICACION: (state, payload) => {
        state.notificaciones = state.notificaciones.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_NOTIFICACION: (state, payload) => {
        state.notificaciones = state.notificaciones.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_NOTIFICACIONES: async ({ commit, state }, { filter, notificacionEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await NotificacionService.get({
                filter,
                notificacionEstado,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_NOTIFICACIONES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las notificaciones, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_NOTIFICACIONES: async ({ commit }) => {
        try {
            let { data, status } = await NotificacionService.getAll()
            if (status === 200) {
                commit("SET_NOTIFICACIONES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se han podido cargar las notificaciones, inténtelo nuevamente"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_NOTIFICACIONES: async ({ commit }) => {
        try {
            let { data, status } = await NotificacionService.getAllRecords()
            if (status === 200) {
                commit("SET_NOTIFICACIONES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las notificaciones, inténtelo nuevamente"
            })
        }
    },

    UPDATE_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await NotificacionService.put(payload)
            if (status === 200) {
                commit("UPDATE_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo de notificación ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { status, data } = await NotificacionService.delete(payload)
            if (status === 204) {
                commit("DELETE_NOTIFICACION", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo de notificación ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo de notificación ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tipo de notificación, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
